import './StatCard.css';

export default function StatCard({ title, value, color, icon, progress }) {
  const borderColor = {
    primary: '#4e73df',
    success: '#1cc88a',
    info: '#36b9cc',
    warning: '#f6c23e',
    dark: '#14b624'
  };

  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div
        className="card shadow h-100 py-2"
        style={{ borderLeft: `4px solid ${borderColor[color]}` }}
      >
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col mr-2">
              <div 
              className={`text-xs font-weight-bold ${color === 'dark' ? 'texto' : `text-${color}`} text-uppercase mb-1`}
              >
                {title}
              </div>
              <div  className={`h5 mb-0 font-weight-bold ${color === 'dark' ? 'texto-green' : `text-gray-800`}`}>
                {value}
                </div>

              {/* Si se pasa la prop progress, renderiza la barra */}
              {progress !== undefined && (
                <div className="row no-gutters align-items-center mt-2">
                  <div className="col-auto">
                    <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                      {progress}%
                    </div>
                  </div>
                  <div className="col">
                    <div className="progress progress-sm mr-2">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${progress}%`,
                          backgroundColor: borderColor[color]
                        }}
                        role="progressbar"
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-auto">
              <i className={`fas ${icon} fa-2x`} style={{ color: '#d1d3e2' }}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
